/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "vehicle-compartments-table",
	props: ["vehicleId", "clearModels"],
	emits: ["capacityChanged", "compartmentRemoved"],
	data() {
		return {
			vehicleCompartmentProducts: [],
			products: [],
			numberOfComponents: 0
		};
	},
	methods: {
		getVehicleCompartmentProducts(){
			systemService.getVehicleCompartmentProducts(this.vehicleId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.vehicleCompartmentProducts = successResponse.data.result;
						this.numberOfComponents = this.vehicleCompartmentProducts.length;
						if(this.vehicleCompartmentProducts.length > 0){
							for(var i = 0; i < this.vehicleCompartmentProducts.length; i++){
								let compartmentProducts = this.vehicleCompartmentProducts[i].compartmentProducts;
								for(var j = 0; j < this.products.length; j++){
									let product = this.products[j];
									let compartmentProduct = compartmentProducts.find(x => x.productId === product.productId);
									if(compartmentProduct === null || compartmentProduct === undefined){
										compartmentProduct = {
											vehicleCompartmentProductId: 0,
											productId: product.productId,
											vehicleCompartmentId: 0,
											capacity: null
										};
										this.vehicleCompartmentProducts[i].compartmentProducts.push(compartmentProduct);
									}
								}
							}
							this.$emit("capacityChanged", this.vehicleCompartmentProducts);
						}
						console.log("this.vehicleCompartmentProducts", this.vehicleCompartmentProducts);
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getProducts() {
			let request = {
				searchQuery: null,
				allowCollection: false,
				allowDelivery: true,
				isActive: true
			};
			productService.getProducts(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.products = successResponse.data.result;
						//this.getVehicleCompartmentProducts();
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onNumberOfComponentsBlur(){
			if(this.vehicleCompartmentProducts === null || this.vehicleCompartmentProducts.length === 0) {
				this.vehicleCompartmentProducts = [];
				for (let i = 0; i < this.numberOfComponents; i++) {
					let compartmentNumber = i + 1;
					let vehicleCompartmentProduct = {
						vehicleCompartment: {
							vehicleCompartmentId: 0,
							vehicleId: this.vehicleId === null ? 0 : this.vehicleId,
							name: "Compartment " + compartmentNumber
						},
						compartmentProducts: []
					};
					for (let j = 0; j < this.products.length; j++) {
						let compartmentProduct = {
							vehicleCompartmentProductId: 0,
							productId: this.products[j].productId,
							vehicleCompartmentId: 0,
							capacity: null
						};
						vehicleCompartmentProduct.compartmentProducts.push(compartmentProduct);
					}

					this.vehicleCompartmentProducts.push(vehicleCompartmentProduct);
				}
			}
			else{
				if(this.numberOfComponents > this.vehicleCompartmentProducts.length){
					this.addCompartments();
				}
				else if(this.numberOfComponents < this.vehicleCompartmentProducts.length){
					this.removeCompartments();
				}
			}
		},
		addCompartments(){
			var numberOfCompartmentsToAdd = this.numberOfComponents - this.vehicleCompartmentProducts.length;
			for (let i = 0; i < numberOfCompartmentsToAdd; i++) {
				let compartmentNumber = this.vehicleCompartmentProducts.length + 1;
				let vehicleCompartmentProduct = {
					vehicleCompartment: {
						vehicleCompartmentId: 0,
						vehicleId: this.vehicleId === null ? 0 : this.vehicleId,
						name: "Compartment " + compartmentNumber
					},
					compartmentProducts: []
				};
				for (let j = 0; j < this.products.length; j++) {
					let compartmentProduct = {
						vehicleCompartmentProductId: 0,
						productId: this.products[j].productId,
						vehicleCompartmentId: 0,
						capacity: null
					};
					vehicleCompartmentProduct.compartmentProducts.push(compartmentProduct);
				}
				
				this.vehicleCompartmentProducts.push(vehicleCompartmentProduct);
			}
		},
		onCapacityInputBlur(vehicleCompartmentProduct){
			this.$emit("capacityChanged", this.vehicleCompartmentProducts);
		},
		removeCompartments(){
			var numberOfCompartmentsToRemove = this.vehicleCompartmentProducts.length - this.numberOfComponents;
			var compartmentsRemoved = [];
			for(var i = 0; i < numberOfCompartmentsToRemove; i++){
				let compartmentRemoved = this.vehicleCompartmentProducts.pop();
				console.log("compartmentRemoved", compartmentRemoved);
				compartmentsRemoved.push(compartmentRemoved.vehicleCompartment.vehicleCompartmentId);
			}
			for(var j = 0; j < this.vehicleCompartmentProducts.length; j++){
				this.vehicleCompartmentProducts[j].vehicleCompartment.name = "Compartment " + (j + 1);
			}
			let compartment = {
				compartmentsRemoved: compartmentsRemoved,
				vehicleCompartmentProducts: this.vehicleCompartmentProducts
			};
			this.$emit("compartmentRemoved", compartment);
		},
		removeCompartment(vehicleCompartmentProduct, index){
			this.vehicleCompartmentProducts.splice(index, 1);
			this.numberOfComponents = this.vehicleCompartmentProducts.length;
			for(var i = 0; i < this.vehicleCompartmentProducts.length; i++){
				this.vehicleCompartmentProducts[i].vehicleCompartment.name = "Compartment " + (i + 1);
			}
			let compartment = {
				compartmentsRemoved: [vehicleCompartmentProduct.vehicleCompartment.vehicleCompartmentId],
				vehicleCompartmentProducts: this.vehicleCompartmentProducts
			};
			this.$emit("compartmentRemoved", compartment);
		}
	},
	mounted: function () {
		this.getProducts();
	},
	unmounted() {
		this.vehicleCompartmentProducts = [];
		this.products = [];
		this.numberOfComponents = 0;
	},
	watch: {
		vehicleId: {
			handler: function () {
				if (this.vehicleId !== null && this.vehicleId > 0) {
					this.getVehicleCompartmentProducts();
				}
			}
		},
		clearModels:{
			handler: function(){
				if(this.clearModels) {
					this.vehicleCompartmentProducts = [];
					this.numberOfComponents = 0;
				}
			}
		}
	}
};